import React, { useRef, useState } from "react";
import { useIntersectionObserver } from "../../../../../../common-deprecated/hooks";
import Preloader from "../../../../../../common-deprecated/styles/toyota/Preloader";
import { useUscSelector } from "../../../../redux/store";
import CoordinatesMap from "../../common/CoordinatesMap";
import { getMapsLink } from "../../../../../shared-logic/utils/uscUtils";
import { UscLabel } from "../../../../utils/labels";
import Button from "../../../../../shared-components/toyota/styles/atoms/Button";
import * as Styles from "./PdpDealer.styles";
import { trackAemDealerMapsLink } from "../../../../utils/tracking";
import { getToyotaButtonVariant } from "../../../../utils/pdpUtils";

const DealerDirections = (): JSX.Element | null => {
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const vehicleType = useUscSelector((state) => state.vehicle.type);

    // Only render the map when it is almost into view. Should help perf and significantly reduce Mapbox usage.
    const mapContainer = useRef<HTMLDivElement>(null);
    const [renderMap, setRenderMap] = useState<boolean>(false);
    useIntersectionObserver(mapContainer, () => setRenderMap(true), false, { rootMargin: "200px" });

    const hasOpeningHours = !!dealer?.openingHours?.length;

    if (!dealer) return null;

    return (
        // data-cpdqm="ignore" => Ignore DQM test for the buttons: 2.4 - Indicate when a link will open in a new window/tab
        <Styles.Map hasOpeninghours={hasOpeningHours} data-cpdqm="ignore">
            <div ref={mapContainer}>
                {renderMap ? (
                    <CoordinatesMap
                        lat={dealer.geoLocation.lat}
                        lon={dealer.geoLocation.lon}
                        zoom={15}
                        type="dynamic"
                    />
                ) : (
                    <Preloader />
                )}
                <Button
                    variant={getToyotaButtonVariant(vehicleType, commonSettings.query.blackPrimaryCtas)}
                    href={getMapsLink(dealer)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackAemDealerMapsLink(vehicleType, dealer)}
                >
                    <UscLabel label="uscDealerGetDirectionsLink" />
                </Button>
            </div>
        </Styles.Map>
    );
};

export default DealerDirections;
